function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, useContext, useMemo } from 'react';
import { mockSlackClient } from "../utils/slack-client";
import { useStateInRef } from 'seagull';
import { mockCookiesManager } from "./CookiesManager";
import { actualReactStripeJs } from "../stripe/reactStripeJs";
function throwUnsetContextError(f) {
  return () => {
    throw new Error("Somebody is trying to use ".concat(f, " without a properly set context"));
  };
}
export const mockIntercom = () => {};
export const mockHotjar = {
  identify() {}
};
export const mockOpenNewTab = () => null;
export const MockReactPlayer = () => /*#__PURE__*/React.createElement(React.Fragment, null);
export const MockYoutubePlayer = () => /*#__PURE__*/React.createElement(React.Fragment, null);
export const MockGoogleButton = () => /*#__PURE__*/React.createElement(React.Fragment, null);
export const MockLoomParser = async () => ({
  type: 'video',
  html: '',
  title: '',
  provider_name: 'Loom',
  provider_url: '',
  thumbnail_height: 0,
  thumbnail_width: 0,
  thumbnail_url: '',
  duration: 0,
  height: null,
  width: null
});
export class MockLocalStorage {
  constructor() {
    _defineProperty(this, "storage", {});
  }
  clear() {
    this.storage = {};
  }
  getItem(key) {
    return key in this.storage ? this.storage[key] : null;
  }
  removeItem(key) {
    delete this.storage[key];
  }
  setItem(key, value) {
    this.storage[key] = value;
  }
}
const Context = /*#__PURE__*/createContext({
  slackClient: mockSlackClient,
  getNow: throwUnsetContextError('getNow'),
  usePlaidLink: throwUnsetContextError('usePlaidLink'),
  locationReload: throwUnsetContextError('locationReload'),
  changeLocation: () => {},
  copyToClipboard: throwUnsetContextError('copyToClipboard'),
  getIntercom: () => mockIntercom,
  getHotjar: () => mockHotjar,
  openNewTab: mockOpenNewTab,
  personaClient: throwUnsetContextError('personaClient'),
  ReactPlayer: MockReactPlayer,
  YoutubePlayer: MockYoutubePlayer,
  GoogleButton: MockGoogleButton,
  loomParser: MockLoomParser,
  uploadFileToCloudStorage: async () => {},
  cookies: mockCookiesManager,
  logBIEvent: () => {},
  localStorage: new MockLocalStorage(),
  downloadCsv: () => {},
  reactStripe: actualReactStripeJs
});
export function IoContextProvider(props) {
  const getStateInRef = useStateInRef(props);
  const value = useMemo(() => {
    const {
      slackClient,
      getNow,
      usePlaidLink,
      locationReload,
      changeLocation,
      copyToClipboard,
      getIntercom,
      getHotjar,
      openNewTab,
      personaClient,
      ReactPlayer,
      YoutubePlayer,
      GoogleButton,
      loomParser,
      uploadFileToCloudStorage,
      cookies,
      logBIEvent,
      localStorage,
      reactStripe,
      downloadCsv
    } = getStateInRef();
    return {
      slackClient,
      getNow,
      usePlaidLink,
      locationReload,
      changeLocation,
      copyToClipboard,
      getIntercom,
      getHotjar,
      openNewTab,
      personaClient,
      ReactPlayer,
      YoutubePlayer,
      GoogleButton,
      loomParser,
      uploadFileToCloudStorage,
      cookies,
      logBIEvent,
      localStorage,
      reactStripe,
      downloadCsv
    };
  }, []);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: value
  }, props.children);
}
export const useIoContext = () => useContext(Context);
export default IoContextProvider;